// extracted by mini-css-extract-plugin
export var active = "_5p-b";
export var activeIndicator = "_5p-6";
export var animate = "_5p-a";
export var disabled = "_5p-c";
export var flat = "_5p-1";
export var fullWidth = "_5p-3";
export var lg = "_5p-9";
export var md = "_5p-8";
export var redoButtonTabGroup = "_5p-0";
export var sm = "_5p-7";
export var tabButton = "_5p-4";
export var tabButtonsContainer = "_5p-2";
export var xs = "_5p-5";